import React, { Component } from 'react';
import { Grid, Icon, Segment, Button, Form, Dropdown } from 'semantic-ui-react';
import { getPendingCancellationsInfo, exportXLSX } from '../../utils/rest';
import BreadcrumbCustom from '../../layout/BreadcrumbCustom';
import ReactTable from 'react-table';
import MessageBox from '../../ui/MessageBox';
import * as SimpleReactValidator from 'simple-react-validator';
import Loading from '../Loading';
const initialState = {
    conFirstName: "",
    conLastName: "",
    from: "",
    to: "",
    acxInvoiceId: "",
    acxAccountId: "",
    cltClientIds: []
}
class CancellationPending extends Component {
    constructor(props) {
        super(props);
        this.validator = new SimpleReactValidator();
        this.state = {
            cancellations: [],
            initialState,
            errorMessage: [],
            openError: false,
            loading: false
        };
    }

    componentDidMount() {
        this.props.addItem("helpFile", "cancel_view-pending-cancellations.md");
    }

    componentWillUnmount() {
        this.props.addItem("helpFile", null);
    }

    handleChange = (e, evt) => {

        this.setState({
            initialState: {
                ...this.state.initialState,
                [evt.name]: evt.value
            }
        });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        if (this.validator.allValid()) {
            this.setState({
                loading: true
            }, () => {
                this.getPendingCancellations();
            });
        } else {
            this.setState({
                errorMessage: this.props._errorItems(this.validator.fields),
                openError: true
            });
            this.forceUpdate();
        }
    }

    checkEmpty = (searchIndex, except) => {
        let r = false;
        for (let search in searchIndex) {
            if (searchIndex[search].length > 0 && except.indexOf(search) === -1) {
                r = true;
                break;
            }
        }
        return r;
    }

    reset = () => {
        this.setState({
            ...this.state.initialState,
            initialState
        })
    }

    getPendingCancellations() {

        getPendingCancellationsInfo(this.props.items.currentCorporate, this.state.initialState).then((response) => {
            if (response !== null && response instanceof Array) {
                this.setState({
                    cancellations: response
                })
            }
        }).then(() => {
            this.setState({
                loading: false
            })
        })


    }

    close = () => {
        this.setState((prevState, props) => {
            return { openError: false };
        });
    }
    render() {
        return (
            <div>
                {this.state.loading ? <Loading /> : ""}
                <BreadcrumbCustom {...this.props} parent="Cancellations" child={[{ name: "View Pending Cancellations", url: null }]} />
                <Grid className="g-bkgd">
                    <Grid.Row>
                        <Grid.Column>
                            <Form className="small">
                                <Form.Group>
                                    <Form.Field width={6} className="required">
                                        <label>Select Client ID(s):</label>
                                        <Dropdown placeholder='Select Client ID(s)' className="fluid" multiple search selection options={this.props.items.clients} name="cltClientIds" value={this.state.initialState.cltClientIds} onChange={this.handleChange} ></Dropdown>
                                        {this.validator.message('Client ID(s)', this.state.initialState.cltClientIds, 'required')}
                                    </Form.Field>
                                    <Form.Field width={10}>
                                    </Form.Field>
                                </Form.Group>
                                <Form.Group widths='equal'>
                                    <Form.Input label={this.props.t("client.account")+":"} placeholder={this.props.t("client.account")} name="acxInvoiceId" value={this.state.initialState.acxInvoiceId} onChange={this.handleChange} />
                                    <Form.Input label={this.props.t("our.account")+":"} placeholder={this.props.t("our.account")} name="acxAccountId" value={this.state.initialState.acxAccountId} onChange={this.handleChange} />
                                    <Form.Input label='Start Date:' placeholder='mm / dd / yyyy' type="date" name="from" value={this.state.initialState.from} onChange={this.handleChange} />
                                    <Form.Input label='End Date:' placeholder='mm / dd / yyyy' type="date" name="to" value={this.state.initialState.to} onChange={this.handleChange} />
                                </Form.Group>
                                <Form.Group>
                                    <Form.Field width={4} >
                                        <Form.Input label='First Name:' placeholder='First Name' name="conFirstName" value={this.state.initialState.conFirstName} onChange={this.handleChange} />
                                    </Form.Field>
                                    <Form.Field width={4} >
                                        <Form.Input label='Last Name:' placeholder='Last Name' name="conLastName" value={this.state.initialState.conLastName} onChange={this.handleChange} />
                                    </Form.Field>
                                    <Form.Field width={4} >
                                        <Button.Group className="small push-down">
                                            <Button onClick={this.reset}>{this.props.t("reset")}</Button>
                                            <Button.Or />
                                            <Button positive onClick={this.handleSubmit}>{this.props.t("submit")}</Button>
                                        </Button.Group>
                                    </Form.Field>
                                </Form.Group>
                            </Form>
                            <Segment.Group>
                                <Segment raised color="grey" inverted>
                                    <h4 className="ui header">
                                        <Icon name="exclamation triangle" />
                                        <div className="content">
                                            Pending Cancellations
                                        </div>
                                    </h4>
                                </Segment>
                                <Grid className="margin-bottom-5">
                                    <Grid.Column width={1} floated='right'>
                                        <Button onClick={() => {
                                            exportXLSX(
                                                {
                                                    "Client Id": "cltClientId",
                                                    "Client Acct#": "acxInvoiceId",
                                                    "Our Acct#": "acxAccountId",
                                                    "Consumer's Last Name": "conLastName",
                                                    "Consumer's First Name": "conFirstName",
                                                    "SSN": "conSsn",
                                                    "DOS": "acxServiceStartDate",
                                                    "Amount Referred": "acxAmountReferred",
                                                    "Cancel Request Date": "cancelRequestDate",
                                                    "Cancel Reason": "cancelReason",
                                                    "Status": "cancelStatus"

                                                }, this.state.cancellations, "Cancellations.xlsx")
                                        }}
                                            className="ui left small icon button icon-export" data-inverted="" data-tooltip="Export Table Details to Spreadsheet" data-position="bottom right">
                                            <i className="file excel icon"></i>
                                        </Button>
                                    </Grid.Column>
                                </Grid>
                                <ReactTable noDataText={null} minRows={0} defaultPageSize={this.props.reactTable().pageSize} showPagination={this.state.cancellations && this.state.cancellations.length > this.props.reactTable().pageSize ? true : false} filterable defaultFilterMethod={this.props._customFilter} className="celled -striped -highlight "
                                    data={this.state.cancellations}
                                    getNoDataProps={() => {
                                        return { style: { display: 'none' } };
                                    }}
                                    columns={[{
                                        Header: props => <span data-inverted="" data-tooltip="Our Client Identifier" data-position="bottom left">Client ID</span>,
                                        accessor: 'cltClientId',
                                        width: 100,
                                    }, {
                                        Header: props => <span data-inverted="" data-tooltip="Your Account Number for this Billing" data-position="bottom left">Client Acct#</span>,
                                        accessor: 'acxInvoiceId',
                                        width: 100,
                                    }, {
                                        Header: props => <span data-inverted="" data-tooltip="Our Agency’s Account Number" data-position="bottom left">Our Acct#</span>,
                                        accessor: 'acxAccountId',
                                        width: 100,
                                    }, {
                                        Header: props => <span data-inverted="" data-tooltip="Consumer’s First & Last Name" data-position="bottom left">{this.props.t("consumer.name")}</span>,
                                        id: 'conFirstName',
                                        accessor: row => (
                                            row.conLastName + " " + row.conFirstName
                                        )
                                    }, {
                                        Header: props => <span data-inverted="" data-tooltip="Consumer’s Social Security Number" data-position="bottom left">SSN</span>,
                                        id: 'conSsn',
                                        width: 90,
                                        accessor: row => (
                                            row.conSsn ? this.props._padString(row.conSsn.toString()) : ""
                                        )
                                    }, {
                                        Header: props => <span data-inverted="" data-tooltip="Date of Service" data-position="bottom left">DOS</span>,
                                        id: 'acxServiceStartDate',
                                        width: 100,
                                        accessor: row => (
                                            row.acxServiceStartDate ? this.props._formatDate(row.acxServiceStartDate) : ""
                                        )
                                    }, {
                                        Header: props => <span data-inverted="" data-tooltip="Amount Referred" data-position="bottom left">AR</span>,
                                        id: 'acxAmountReferred',
                                        width: 100,
                                        style: {
                                            textAlign: "right"
                                        },
                                        accessor: row => (
                                            row.acxAmountReferred ? this.props._currencyFormat(row.acxAmountReferred) : "0.00"
                                        )
                                    }, {
                                        Header: props => <span data-inverted="" data-tooltip="Currency Code" data-position="bottom left">Currency Code</span>,
                                        accessor: 'currencyCode',
                                    },{
                                        Header: props => <span data-inverted="" data-tooltip="The Date of Cancellation Request" data-position="bottom left">Cancel Request Date</span>,
                                        id: 'cancelRequestDate',
                                        width: 100,
                                        accessor: row => (
                                            row.cancelRequestDate ? this.props._formatDate(row.cancelRequestDate) : ""
                                        )
                                    }, {
                                        Header: props => <span data-inverted="" data-tooltip="Reason for Hold or Cancel" data-position="bottom left">Reason</span>,
                                        accessor: 'cancelReason',
                                    }, {
                                        Header: props => <span data-inverted="" data-tooltip="Is Cancellation Rejected/Approved/Pending" data-position="bottom right">Status</span>,
                                        id: 'cancelStatus',
                                        width: 100,
                                        style: {
                                            textAlign: "center"
                                        },
                                        accessor: row => (
                                            row.cancelStatus === "R" ? "Approved" : (row.cancelStatus === "C" ? "Rejected" : "Pending")
                                        )
                                    }]}
                                />
                            </Segment.Group>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <MessageBox {...this.props} size="mini" box={11} open={this.state.openError} close={this.close} required={this.state.errorMessage} />
            </div>
        );
    }
}
export default CancellationPending;


// WEBPACK FOOTER //
// ./src/app/ui/cancellations/CancellationPending.js